/**
 * Filter agenda resources/appointments/time-off to the session employee's
 * linked resources when canViewOthers is false.
 */
export function filterAgendaOwnScope<
  TResource extends { id: string; employeeId?: string | null },
  TAppt extends { resourceId: string },
  TOff extends { resourceId: string },
>(input: {
  resources: TResource[];
  appointments: TAppt[];
  timeOffs: TOff[];
  canViewOthers: boolean;
  sessionEmployeeId: string | null;
}): {
  resources: TResource[];
  appointments: TAppt[];
  timeOffs: TOff[];
  noLinkedResource: boolean;
} {
  if (input.canViewOthers) {
    return {
      resources: input.resources,
      appointments: input.appointments,
      timeOffs: input.timeOffs,
      noLinkedResource: false,
    };
  }

  const empId = input.sessionEmployeeId;
  const resources = empId ? input.resources.filter((r) => r.employeeId === empId) : [];
  const allowedIds = new Set(resources.map((r) => r.id));
  return {
    resources,
    appointments: input.appointments.filter((a) => allowedIds.has(a.resourceId)),
    timeOffs: input.timeOffs.filter((o) => allowedIds.has(o.resourceId)),
    noLinkedResource: resources.length === 0,
  };
}
